import {Component} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {Clipboard} from "@angular/cdk/clipboard";
import {MessageHelper} from "../../../core/helper/message-helper";
import { AppMessageService } from "../../../core/service/app-message.service";


@Component({
  selector: 'refer-friend',
  templateUrl: './refer-friend.component.html',
  styleUrls: ['./refer-friend.component.css']
})
export class ReferFriendComponent extends CoreComponent {

  referFriendText: string | undefined;
  shareDialog: boolean = false;

  constructor(protected router: Router,
              protected userApiService: UserApiService,
              protected clipboardService: Clipboard,
              protected messageService: AppMessageService,
              protected formBuilder: FormBuilder,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.getReferFriendText();
    this.refreshComponent();
  }

  getReferFriendText() {
    this.userApiService.referFriend().subscribe(res =>{
      this.referFriendText = res.text;
      this.initialized = true;
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);

    })
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
  }

  handleCopyClipboard() {
    this.clipboardService.copy(this.referFriendText as string);
  }

  navigateToWhatsApp() {
    const encodedText = encodeURIComponent(this.referFriendText as string);
    window.open(`https://wa.me/?text=${encodedText}`, '_blank');
  }

  navigateToMessenger() {
    this.handleCopyClipboard();
    window.open('https://m.me/', '_blank');
  }

  navigateToFacebook() {
    const urlToShare = this.getReferralUrl();
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare.url as string)}`;
    window.open(facebookShareUrl, '_blank');
  }

  getReferralUrl(): { url: string, text: string | undefined } {
    // Regular expression modified to match URLs starting with "www" as well
    const urlRegex = /(https?:\/\/)?www\.[^\s]+/g;
    const matches = this.referFriendText?.match(urlRegex);

    if (matches && matches.length > 0) {
      const url = matches[0];
      const text = this.referFriendText?.split(url)[0];

      return { url, text };
    }

    return { url: '', text: undefined }; // Adjusted to match your specified return type
  }


  navigateToTelegram() {
    const baseUrl = "https://t.me/share/url";
    const textToShare = this.getReferralUrl();
    const urlToShare = textToShare.url;
    const message = textToShare.text as string;
    const telegramUrl = `${baseUrl}?url=${encodeURIComponent(urlToShare)}&text=${encodeURIComponent(message)}`;

    window.open(telegramUrl, '_blank');
  }


}
